import { Component, ErrorInfo, ReactNode } from 'react';

interface Props { children: ReactNode }
interface State { error: Error | null }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#0f1117', color: '#e2e8f0', fontFamily: 'system-ui,sans-serif', gap: 16 }}>
          <h2 style={{ fontSize: 22, margin: 0 }}>Something went wrong</h2>
          <p style={{ color: '#94a3b8', margin: 0 }}>Please refresh the page. If the problem persists, contact support.</p>
          <button onClick={() => window.location.reload()} style={{ marginTop: 8, padding: '10px 24px', background: '#5B4FE8', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}>
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
